<div  id="pollSlider-button" class="sidebar-outer"  >
    <!-- <a class="logo d-flex align-items-center"  (click)="closeSubMenus()" *ngIf="settings.theme.sidebarIsFixed">
        <img src="/assets/img/logo.jpg" width="30px"> &nbsp;<span class="start">D</span><span class="ng">K</span>
        <b _ngcontent-skc-c4=""><span _ngcontent-skc-c4="" style="color:#00786a;font-weight: bold">CFSS</span>
            <span _ngcontent-skc-c4="" style="color:#689F38;font-weight: bold">Care </span>
             <span _ngcontent-skc-c4="" style="color:black">&nbsp;Software</span></b>
    </a> -->
    <app-vertical-menu [menuItems]="menuItems"></app-vertical-menu>    
</div>